import { useState } from 'react';

import { GridRowModes } from '@mui/x-data-grid';
import { GridRowModesModel } from '@mui/x-data-grid';
import { randomId } from '@mui/x-data-grid-generator';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

export const useAgenda = () => {
  const [agenda, setAgenda] = useState<GenericObject[]>([]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const handleChangeAgenda = (newAgenda: GenericObject[]) => {
    setAgenda(newAgenda);
  };

  const handleChangeRowModesModel = (newModel: GridRowModesModel) => {
    setRowModesModel(newModel);
  };

  const handleClickAddAgenda = () => {
    const id = randomId();
    setAgenda((oldAgenda: GenericObject[]) => [
      ...oldAgenda,
      { id, time: '', title: '', description: '', isNew: true },
    ]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: 'time' },
    }));
  };

  return { agenda, rowModesModel, handleChangeAgenda, handleChangeRowModesModel, handleClickAddAgenda };
};
